import { useEffect, useState } from "react";
import { getLocalStorage } from "../constants/localStorage";

export function useRole() {
  const [role, setRole] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = getLocalStorage("adminUser");
    if (userData) {
      setRole(userData?.role);
      setUser(userData);
    }
  }, []);

  return { role, user };
}
